import React, { useEffect, useState } from "react";
import moment from "moment";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { getDashboardTaskByDate } from "../../../../api/dashboard";
import "./dashboard-chart-section.scss"

const MyTaskChartSection: any = (props: any) => {
  const [expanded, setExpanded] = useState<string | false>(false);
  const [taskData, setTaskData] = useState<any>(null);
  const { date, setLoading, setAlertOpen, setAlertMessage, setAlertType } =
    props;

  const fetchTaskByDate = async (dateInfo: any) => {
    setLoading(true);
    try {
      const response = await getDashboardTaskByDate(dateInfo.format());
      setTaskData(response?.data?.data?.data || null);
      setLoading(false);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch campaigns"
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTaskByDate(date);
  }, [date]);

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <div className="dashboard-chart-section-cards dashboard-chart-section-cards-task">
      {/* <div className="dashboard-chart-section-cards-heading">My Tasks</div> */}
      <div className="dashboard-chart-section-cards-task-section">
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          disableGutters
            elevation={0}
            sx={{
              boxShadow: "none",
              padding: "0px",
              "&:before": { display: "none" },
              margin: 0,
              "&.Mui-expanded": {
                margin: 0,
              },
              "& .MuiAccordionSummary-root": {
                padding: 0,
                minHeight: "auto",
              },
              "& .MuiAccordionSummary-content": {
                margin: 0,
              },
              "& .MuiAccordionDetails-root": {
                padding: 0,
              },
            }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
            sx={{
              "&.Mui-focusVisible, &:focus, &:active": {
                backgroundColor: "transparent", // Remove background
                boxShadow: "none",
                outline: "none",
              },
              "& *": {
                userSelect: "none", // Prevent accidental selection
              },
            }}
          >
            <div className="dashboard-chart-section-cards-task-section-heading">
              <div className="dashboard-chart-section-cards-task-section-heading-main">
                Tasks
              </div>
              <div className="dashboard-chart-section-cards-task-section-heading-sub">
                {taskData?.tasksCount || 0}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="dashboard-chart-section-cards-task-section-list">
              {taskData?.tasksCount > 0 ? (
                taskData?.tasks?.map((task: any, index: number) => (
                  <div
                    className="dashboard-chart-section-cards-task-section-list-items"
                    key={index}
                  >
                    <div className="dashboard-chart-section-cards-task-section-list-items-main">
                      <i className="fa fa-circle" /> {task?.subject || "-"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="dashboard-chart-section-cards-task-section-list-items">
                  <div className="dashboard-chart-section-cards-task-section-heading-main">
                    {" "}
                    {"No tasks scheduled for this day."}
                  </div>
                </div>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              "&.Mui-focusVisible, &:focus, &:active": {
                backgroundColor: "transparent", // Remove background
                boxShadow: "none",
                outline: "none",
              },
              "& *": {
                userSelect: "none", // Prevent accidental selection
              },
            }}
          >
            <div className="dashboard-chart-section-cards-task-section-heading">
              <div className="dashboard-chart-section-cards-task-section-heading-main">
                Meetings
              </div>
              <div className="dashboard-chart-section-cards-task-section-heading-sub">
                {taskData?.meetingsCount || 0}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="dashboard-chart-section-cards-task-section-list">
              {taskData?.meetingsCount > 0 ? (
                taskData?.meetings?.map((meeting: any, index: number) => (
                  <div
                    className="dashboard-chart-section-cards-task-section-list-items"
                    key={index}
                  >
                    <div className="dashboard-chart-section-cards-task-section-list-items-main">
                      <i className="fa fa-circle" /> {meeting?.title || "-"}
                    </div>
                    <div className="dashboard-chart-section-cards-task-section-list-items-sub">
                      {moment(meeting?.meetStartTime).format("LT") || "-"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="dashboard-chart-section-cards-task-section-list-items">
                  <div className="dashboard-chart-section-cards-task-section-heading-main">
                    {" "}
                    {"No meetings scheduled for this day."}
                  </div>
                </div>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              "&.Mui-focusVisible, &:focus, &:active": {
                backgroundColor: "transparent", // Remove background
                boxShadow: "none",
                outline: "none",
              },
              "& *": {
                userSelect: "none", // Prevent accidental selection
              },
            }}
          >
            <div className="dashboard-chart-section-cards-task-section-heading">
              <div className="dashboard-chart-section-cards-task-section-heading-main">
                Calls
              </div>
              <div className="dashboard-chart-section-cards-task-section-heading-sub">
                {taskData?.callsCount || 0}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="dashboard-chart-section-cards-task-section-list">
              {taskData?.callsCount > 0 ? (
                taskData?.calls?.map((call: any, index: number) => (
                  <div
                    className="dashboard-chart-section-cards-task-section-list-items"
                    key={index}
                  >
                    <div className="dashboard-chart-section-cards-task-section-list-items-main">
                      <i className="fa fa-circle" />{" "}
                      {call?.subject || call?.fullName || "-"}
                    </div>
                    <div className="dashboard-chart-section-cards-task-section-list-items-sub">
                      {moment(call?.call_start_time).format("LT") || "-"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="dashboard-chart-section-cards-task-section-list-items">
                  <div className="dashboard-chart-section-cards-task-section-heading-main">
                    {" "}
                    {"No calls scheduled for this day."}
                  </div>
                </div>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel5"}
          onChange={handleChange("panel5")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              "&.Mui-focusVisible, &:focus, &:active": {
                backgroundColor: "transparent", // Remove background
                boxShadow: "none",
                outline: "none",
              },
              "& *": {
                userSelect: "none", // Prevent accidental selection
              },
            }}
          >
            <div className="dashboard-chart-section-cards-task-section-heading">
              <div className="dashboard-chart-section-cards-task-section-heading-main">
                Reminders
              </div>
              <div className="dashboard-chart-section-cards-task-section-heading-sub">
                {taskData?.remindersCount || 0}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="dashboard-chart-section-cards-task-section-list">
              {taskData?.remindersCount > 0 ? (
                taskData?.reminders?.map((reminder: any, index: number) => {
                  if (reminder?.task) {
                    return (
                      <div
                        className="dashboard-chart-section-cards-task-section-list-items"
                        key={index}
                      >
                        <div className="dashboard-chart-section-cards-task-section-list-items-main">
                          <i className="fa fa-circle" />{" "}
                          {reminder?.task?.subject || "-"}
                        </div>
                        <div className="dashboard-chart-section-cards-task-section-list-items-sub">
                          {reminder?.task?.reminder || "-"}
                        </div>
                      </div>
                    );
                  } else if (reminder?.meeting) {
                    return (
                      <div
                        className="dashboard-chart-section-cards-task-section-list-items"
                        key={index}
                      >
                        <div className="dashboard-chart-section-cards-task-section-list-items-main">
                          <i className="fa fa-circle" />{" "}
                          {reminder?.meeting?.title || "-"}
                        </div>
                        <div className="dashboard-chart-section-cards-task-section-list-items-sub">
                          {reminder?.meeting?.reminder || "-"}
                        </div>
                      </div>
                    );
                  } else {
                    return "";
                  }
                })
              ) : (
                <div className="dashboard-chart-section-cards-task-section-list-items">
                  <div className="dashboard-chart-section-cards-task-section-heading-main">
                    {" "}
                    {"No reminders scheduled for this day."}
                  </div>
                </div>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === "panel4"}
          onChange={handleChange("panel4")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
            sx={{
              "&.Mui-focusVisible, &:focus, &:active": {
                backgroundColor: "transparent", // Remove background
                boxShadow: "none",
                outline: "none",
              },
              "& *": {
                userSelect: "none", // Prevent accidental selection
              },
            }}
          >
            <div className="dashboard-chart-section-cards-task-section-heading">
              <div className="dashboard-chart-section-cards-task-section-heading-main">
                Leads
              </div>
              <div className="dashboard-chart-section-cards-task-section-heading-sub">
                {taskData?.leadsCount || 0}
              </div>
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="dashboard-chart-section-cards-task-section-list">
              {taskData?.leadsCount > 0 ? (
                taskData?.leads?.map((lead: any, index: number) => (
                  <div
                    className="dashboard-chart-section-cards-task-section-list-items"
                    key={index}
                  >
                    <div className="dashboard-chart-section-cards-task-section-list-items-main">
                      <i className="fa fa-circle" /> {lead?.fullName || "-"}
                    </div>
                    <div className="dashboard-chart-section-cards-task-section-list-items-sub">
                      {moment(lead?.created_at).format("LT") || "-"}
                    </div>
                  </div>
                ))
              ) : (
                <div className="dashboard-chart-section-cards-task-section-list-items">
                  <div className="dashboard-chart-section-cards-task-section-heading-main">
                    {" "}
                    {"No leads for this day."}
                  </div>
                </div>
              )}
            </div>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};
export default MyTaskChartSection;
